import { render, staticRenderFns } from "./PurchaseCard.vue?vue&type=template&id=f1ef7a70&scoped=true&"
import script from "./PurchaseCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseCard.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseCard.vue?vue&type=style&index=0&id=f1ef7a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ef7a70",
  null
  
)

export default component.exports